import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
// Components
import Topbar from "../../components/Topbar/Topbar"
import Sidebar from "../../components/Sidebar/Sidebar"
import Checkbox from "../../components/Checkbox/Checkbox"
// Data
import { createServiceRequest } from "../../redux/apiCalls"
// Styles
import {
   Container,
   Wrapper,
   Main,
   WideBox,
   StyledForm,
   FormItem,
   StyledLabel,
   StyledInput,
   StyledSelect,
   StyledOption,
   StyledTextArea,
   GeneralInfo,
   ButtonContainer,
   ButtonWrapper,
   StyledButton,
   Message,
   TitleWrapper,
   Title,
} from "./NewServiceRequest.styles"

const NewServiceRequest = () => {
   const dispatch = useDispatch()
   const navigate = useNavigate()
   const [errorMessage, setErrorMessage] = useState("")
   const [requestInputs, setRequestInputs] = useState({})

   const [sent, setSent] = useState(false)
   const sentChange = () => {
      setRequestInputs((prev) => {
         return {
            ...prev,
            replacementSent: !sent,
         }
      })
      setSent((current) => !current)
   }

   const [returned, setReturned] = useState(false)
   const returnedChange = () => {
      setRequestInputs((prev) => {
         return {
            ...prev,
            returnOk: !returned,
         }
      })
      setReturned((current) => !current)
   }

   const [invoiced, setInvoiced] = useState(false)
   const invoicedChange = () => {
      setRequestInputs((prev) => {
         return {
            ...prev,
            invoiced: !invoiced,
         }
      })
      setInvoiced((current) => !current)
   }

   const [credited, setCredited] = useState(false)
   const creditedChange = () => {
      setRequestInputs((prev) => {
         return {
            ...prev,
            credited: !credited,
         }
      })
      setCredited((current) => !current)
   }

   const handleChange = (e) => {
      setRequestInputs((prev) => {
         return { ...prev, [e.target.name]: e.target.value }
      })
   }

   const handleSubmit = async (e) => {
      e.preventDefault()
      const res = await createServiceRequest(requestInputs, dispatch)
      if (res === "success") {
         navigate("/services")
      } else {
         setErrorMessage(JSON.stringify(res))
      }
   }

   return (
      <>
         <Topbar />
         <Container>
            <Wrapper>
               <Sidebar />
            </Wrapper>
            <Main>
               <TitleWrapper>
                  <Title>New Service Request</Title>
               </TitleWrapper>
               <WideBox>
                  <StyledForm>
                     <GeneralInfo>
                        <FormItem>
                           <StyledLabel>User Id</StyledLabel>
                           <StyledInput
                              type="text"
                              name="userId"
                              onChange={handleChange}
                           />
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Request Date</StyledLabel>
                           <StyledInput
                              type="date"
                              name="requestDate"
                              onChange={handleChange}
                           />
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Spare Part</StyledLabel>
                           <StyledSelect
                              name="sparePart"
                              id="sparePart"
                              onChange={handleChange}
                           >
                              <StyledOption value="full">
                                 Full frame
                              </StyledOption>
                              <StyledOption value="temples">
                                 Both temples
                              </StyledOption>
                              <StyledOption value="left">
                                 Left temple
                              </StyledOption>
                              <StyledOption value="right">
                                 Right temple
                              </StyledOption>
                              <StyledOption value="endtips">
                                 End tips
                              </StyledOption>
                              <StyledOption value="nosepads">
                                 Nosepads
                              </StyledOption>
                           </StyledSelect>
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Product Ref</StyledLabel>
                           <StyledInput
                              type="text"
                              name="productRef"
                              onChange={handleChange}
                           />
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Comments</StyledLabel>
                           <StyledTextArea
                              name="comments"
                              onChange={handleChange}
                           />
                        </FormItem>
                        <FormItem>
                           <StyledLabel>
                              <Checkbox onChange={sentChange} />
                              Sent
                           </StyledLabel>
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Date Replacement Shipped</StyledLabel>
                           <StyledInput
                              type="date"
                              name="dateReplacementShipped"
                              onChange={handleChange}
                           />
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Carrier URL</StyledLabel>
                           <StyledInput
                              type="text"
                              name="carrierUrl"
                              onChange={handleChange}
                           />
                        </FormItem>
                        <FormItem>
                           <StyledLabel>
                              <Checkbox onChange={returnedChange} />
                              Return ok
                           </StyledLabel>
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Date Return Received</StyledLabel>
                           <StyledInput
                              type="date"
                              name="dateReturnReceived"
                              onChange={handleChange}
                           />
                        </FormItem>
                        <FormItem>
                           <StyledLabel>
                              <Checkbox onChange={invoicedChange} />
                              Invoiced
                           </StyledLabel>
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Invoice Date</StyledLabel>
                           <StyledInput
                              type="date"
                              name="invoicedDate"
                              onChange={handleChange}
                           />
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Invoice Number</StyledLabel>
                           <StyledInput
                              type="text"
                              name="invoiceNumber"
                              onChange={handleChange}
                           />
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Invoice Amount</StyledLabel>
                           <StyledInput
                              type="number"
                              name="invoiceAmount"
                              onChange={handleChange}
                           />
                        </FormItem>
                        <FormItem>
                           <StyledLabel>
                              <Checkbox onChange={creditedChange} />
                              Credited
                           </StyledLabel>
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Credit Note Date</StyledLabel>
                           <StyledInput
                              type="date"
                              name="creditNoteDate"
                              onChange={handleChange}
                           />
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Credit Note Number</StyledLabel>
                           <StyledInput
                              type="text"
                              name="creditNoteNumber"
                              onChange={handleChange}
                           />
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Credit Note Amount</StyledLabel>
                           <StyledInput
                              type="number"
                              name="creditNoteAmount"
                              onChange={handleChange}
                           />
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Product Id</StyledLabel>
                           <StyledInput
                              type="text"
                              name="productId"
                              onChange={handleChange}
                           />
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Product Code</StyledLabel>
                           <StyledInput
                              type="text"
                              name="productCode"
                              onChange={handleChange}
                           />
                        </FormItem>
                     </GeneralInfo>
                  </StyledForm>
               </WideBox>
               <ButtonContainer>
                  <ButtonWrapper>
                     <StyledButton onClick={handleSubmit}>Create</StyledButton>
                     <Message>{errorMessage}</Message>
                  </ButtonWrapper>
               </ButtonContainer>
            </Main>
         </Container>
      </>
   )
}

export default NewServiceRequest
